import { Sender } from 'xstate';

import config from '@/config';
import asyncCallback from '@/framework/logic/utils/asyncCallback';
import { LogicContext } from '@/logic/main/types';

export const watchJackpotBetFeeds = (context: LogicContext) =>
  asyncCallback(
    async (
      callback: Sender<{
        type: 'UPDATE_JACKPOT_BET_FEEDS';
      }>
    ) => {
      let intervalToken: ReturnType<typeof setInterval>;

      intervalToken = setInterval(async () => {
        callback({
          type: 'UPDATE_JACKPOT_BET_FEEDS',
        });
      }, config.intervals.jackpotBet.feeds);

      return () => {
        if (intervalToken) {
          clearInterval(intervalToken);
        }
      };
    }
  );
